var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"d-flex mx-5",on:{"submit":function($event){$event.preventDefault();}}},[_c('vue-simple-suggest',{ref:"searchNode",staticClass:"input-wrap node-search",attrs:{"type":"search","placeholder":_vm.$t('comp_graph--searchPlaceholder'),"aria-label":"Search","list":_vm.newList,"debounce":200,"controls":{
      selectionUp: [38, 33],
      selectionDown: [40, 34],
      select: [13, 36],
      showList: [40],
      hideList: [27, 35],
    },"nullable-select":true,"value-attribute":"id","display-attribute":"text"},on:{"suggestion-click":_vm.onSuggestClick},model:{value:(_vm.searchWord),callback:function ($$v) {_vm.searchWord=$$v},expression:"searchWord"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }